export default __webpack_public_path__ + "static/stackblitz-6564b60411d5a0bd089fc17e750928e7.svg";